module.exports = __webpack_public_path__ + "img/ShareAndImport_Mockup.1878f2ab.png";